import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import translate from "../../i18n/translate";
import {
  getSellerReports,
  updateTransaction,
} from "../../actions/reportsAction";
import { getDiscounts } from "../../actions/discountsAction";
import {
  getSellers,
  getTopUpAccounts,
} from "../../actions/sellerCreditsAction";
import "./report.css";
import { connect, useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Checkbox from "@mui/material/Checkbox";
import Dropdown from "react-dropdown";
import "react-datepicker/dist/react-datepicker.css";
// Removed ArrowForwardIcon; using inline nav icons inside date inputs
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ReportHeader from "./ReportHeader";
import { useIntl } from "react-intl";
// import Pagination from "@mui/material/Pagination";
import { getGamingCards } from "../../actions/gameAction";
import { isArray } from "lodash";
import Select from "react-select";
import Button from "../common/Button";
import Modal from "../common/Modal";

import UserTypesDropdown from "../../core/core-components/UserTypesDropdown/UserTypesDropdown";
import {
  formatSellerOptionsForSelect,
  formatTopUpAccountsOptionsForSelect,
} from "../../shared/utils/formatUtils";
import SaleReportTable from "../../core/core-components/SaleReportTable/SaleReportTable";
import { GET_SELLER_REPORTS } from "../../actions/types";
import DatePicker from "react-datepicker";
import CancelableInput from "core/core-components/CancelableInput/CancelableInput";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import IconButton from "@mui/material/IconButton";
import {
  Grid,
  TextField,
  Typography,
  Box,
} from "../../../node_modules/@mui/material/index";
import { conditionalReturn } from "shared/utils/utils";
import { makeStyles } from "../../../node_modules/@mui/styles/index";
import reportStyles from "./reportStyles";
import classNames from "../../../node_modules/classnames/index";
import { CARD_TYPES } from "shared/constants/constants";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { jsonParser } from "shared/utils/ppUtils";
import ApiRequest from "../../actions/ApiRequest";
import SelectSeller from "components/cards/SelectSeller";
import { cleanStorage } from "shared/utils/cleanStorage";

const transactionOptions = [
  { value: "success", label: translate("Success") },
  { value: "failed", label: translate("Failed") },
  { value: "proccessing", label: translate("Processing") },
];

const useStyle = makeStyles(reportStyles);

const Report = ({
  sellerReports,
  getSellerReports,
  discounts,
  getDiscounts,
  auth,
  getSellers,
  sellers,
  isDarktheme,
  updateTransaction,
  updateTransactionLoading,
}) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const options = [
    { value: "", label: translate("Select Trans type") },
    { value: "topup", label: translate("topup") },
    { value: "cancelation", label: translate("cancelation") },
    { value: "add credits", label: translate("add credits") },
    { value: "sales", label: translate("sales") },
  ];

  const transStatusOptions = [
    { value: "", label: translate("Select Status") },
    { value: "success", label: translate("success") },
    { value: "failed", label: translate("failed") },
    { value: "pending", label: translate("pending") },
  ];

  const cardTypeOptions = [
    { value: "", label: translate("Select Card Type") },
    ...Object.values(CARD_TYPES),
  ];
  const sellerId = useSelector((state) => state.auth.user?.id);

  const now = new Date();

  const [dateTo, setDateTo] = useState(now);
  const [dateFrom, setDateFrom] = useState(now);
  const classes = useStyle();
  const [note, setNote] = useState("");
  const [phone, setPhone] = useState("");
  const [transStatus, setTransStatus] = useState({
    value: "",
    label: translate("Select Status"),
  });
  const [transType, setTransType] = useState({
    value: "",
    label: translate("Select Trans type"),
  });
  const [provider, setProvider] = useState({
    value: "",
    label: translate("Select Provider"),
  });
  const [cardType, setCardType] = useState({
    value: "",
    label: translate("Select Card Type"),
  });
  const [sellersOptions, setSellerOptions] = useState([]);
  const [seller, setSeller] = useState(null);
  const [selectedUserType, setSelectedUserType] = useState();
  const [settingLoading, setSettingLoading] = useState(false);
  const [transId, setTransId] = useState("");
  const [cardId, setCardId] = useState("");
  const [amount, setAmount] = useState("");
  const [location, setLocation] = useState("");
  const [renew, setAutoRenew] = useState(false);
  const [companies, setCompanies] = useState([]);

  const [cancelRequest, setCancelRequests] = useState(false);
  const [canceled, setCanceled] = useState(false);
  const [autoRun, setAutoRun] = useState(false);
  const [disableAttr, setDisableAttr] = useState(false);
  const [isAdminSearching, setIsAdminSearching] = useState(false);
  const [showBillerTotals, setShowBillerTotals] = useState(false);
  
  // Debug: Monitor isAdminSearching state changes
  useEffect(() => {
    console.log('🔄 State changed - isAdminSearching:', isAdminSearching);
    console.log('🔄 State changed - autoRun:', autoRun);
  }, [isAdminSearching, autoRun]);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showScrollBottom, setShowScrollBottom] = useState(false);

  const [loading, isLoading] = useState(false);

  const reqInterval = useRef(null);
  const [updateTransactionModal, setUpdateTransactionModal] = useState(false);
  const [updateTransactionStatus, setUpdateTransactionStatus] = useState({
    value: "",
    label: "Select Trans type",
  });
  const [updateTransactionData, setUpdateTransactionData] = useState({
    transid: "",
    value: "",
  });
  const [resellerId, setResellerId] = useState("");
  const [topUpAccountNo, setTopUpAccountNo] = useState();
  const topUpAccounts = useSelector((state) => state.credits.topUpAccounts);
  const intl = useIntl();
  const isAdminSeller = auth.user?.seller_type === "admin";
  const isReseller = auth.user?.seller_type === "reseller";
  const allSellers = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: GET_SELLER_REPORTS,
      payload: [],
    });
    cleanStorage();
  }, [dispatch]);

  useEffect(() => {
    document.title = "Report | Phone Play";
    if (!discounts?.length) {
      getDiscounts();
    }
    if (isAdminSeller || isReseller) {
      // Set initial seller value
      setSeller({ value: "", label: translate("Select all") });
      
      try {
        getSellers(isReseller ? sellerId : null).then((response) => {
          const data = response?.all_sellers;
          if (isArray(data) && data.length > 0) {
            allSellers.current = data;
            const formattedOptions = [
              { value: "", label: translate("Select all") },
              ...formatSellerOptionsForSelect(data)
            ];
            setSellerOptions(formattedOptions);
          }
        });
      } catch (e) {
        console.error("Error fetching sellers:", e);
      }
    }
    
    if (isAdminSeller) {
      dispatch(getTopUpAccounts());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdminSeller, isReseller, dispatch]);

  // Scroll buttons visibility handler
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Show "Back to Top" button after scrolling 300px down
      if (scrollPosition > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
      
      // Show "Go to Bottom" button when not at bottom
      // Hide it when within 300px of the bottom
      if (scrollPosition + windowHeight < documentHeight - 300) {
        setShowScrollBottom(true);
      } else {
        setShowScrollBottom(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Initial check
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    let providers = [];
    providers = discounts.map((discount) => ({
      value: discount.product,
      label: discount.product,
    }));
    providers = [
      { value: "", label: translate("Select Provider") },
      { label: "Peletalk", value: "peletalk" },
      ...providers,
    ];

    setCompanies(providers);

    return () => stopRequest();
  }, [discounts]);

  useEffect(() => {
    if (sellerReports.length) {
      setTotalCount(Number(sellerReports[0].total_count));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sellerReports]);

  useEffect(() => {
    if (autoRun) {
      setDisableAttr(true);
    } else {
      setDisableAttr(false);
    }
  }, [autoRun]);

  useEffect(
    function () {
      if (!allSellers.current) return;

      if (selectedUserType) {
        let sellersOptionsData = [
          { value: "", label: translate("Select all") },
          ...formatSellerOptionsForSelect(
            allSellers.current.filter((v) => v.type === selectedUserType?.value)
          )
        ];
        setSellerOptions(sellersOptionsData);
        setSeller({ value: "", label: translate("Select all") });
      } else {
        const formattedOptions = [
          { value: "", label: translate("Select all") },
          ...formatSellerOptionsForSelect(allSellers.current)
        ];
        setSellerOptions(formattedOptions);
        setSeller({ value: "", label: translate("Select all") });
      }
    },
    [selectedUserType]
  );

  const stopRequest = useCallback(() => {
    console.log('🛑 Stopping interval...');
    if (reqInterval.current) {
      console.log('Clearing interval:', reqInterval.current);
      clearInterval(reqInterval.current);
      reqInterval.current = null;
    }
    console.log('Setting isAdminSearching to FALSE');
    setIsAdminSearching(false);
    setAutoRun(false);
    console.log('✅ Auto-refresh stopped');
  }, []);

  const getReportData = useCallback((page = pageNumber, rowsCount = rowsPerPage) => {
    isLoading(true);
    getSellerReports(
      moment(dateFrom).format("YYYY-MM-DD"),
      moment(dateTo).format("YYYY-MM-DD"),
      phone,
      transType.value,
      transStatus.value,
      transId,
      cardId,
      cancelRequest,
      canceled,
      amount,
      renew,
      provider.value,
      cardType.value,
      page,
      rowsCount,
      seller ? seller?.value : jsonParser(localStorage.currentUser).id,
      resellerId,
      topUpAccountNo?.value,
      location,
      "sales",
      note
    ).then(() => {
      isLoading(false);
    });
  }, [dateFrom, dateTo, phone, transType.value, transStatus.value, transId, cardId, cancelRequest, canceled, amount, renew, provider.value, cardType.value, seller, resellerId, topUpAccountNo?.value, location, note, getSellerReports, pageNumber, rowsPerPage]);

  const startRequest = useCallback(() => {
    console.log('▶ Starting auto-refresh interval...');
    console.log('Setting isAdminSearching to TRUE');
    setIsAdminSearching(true);
    
    // Perform initial search
    console.log('Performing initial search...');
    getSellerReports(
      moment(dateFrom).format("YYYY-MM-DD"),
      moment(dateTo).format("YYYY-MM-DD"),
      phone,
      transType.value,
      transStatus.value,
      transId,
      cardId,
      cancelRequest,
      canceled,
      amount,
      renew,
      provider.value,
      cardType.value,
      "0",
      rowsPerPage,
      seller ? seller?.value : jsonParser(localStorage.currentUser).id,
      resellerId,
      topUpAccountNo?.value,
      location,
      "sales"
    );
    
    console.log('Creating interval to run every 5 seconds...');
    reqInterval.current = setInterval(() => {
      console.log('⏰ Auto-refresh tick - fetching reports...');
      getSellerReports(
        moment(dateFrom).format("YYYY-MM-DD"),
        moment(dateTo).format("YYYY-MM-DD"),
        phone,
        transType.value,
        transStatus.value,
        transId,
        cardId,
        cancelRequest,
        canceled,
        amount,
        renew,
        provider.value,
        cardType.value,
        "0",
        rowsPerPage,
        seller ? seller?.value : jsonParser(localStorage.currentUser).id,
        resellerId,
        topUpAccountNo?.value,
        location,
        "sales"
      );
    }, 5000);
  }, [dateFrom, dateTo, phone, transType.value, transStatus.value, transId, cardId, cancelRequest, canceled, amount, renew, provider.value, cardType.value, rowsPerPage, seller, resellerId, topUpAccountNo?.value, location, getSellerReports]);

  const handleSearch = useCallback(() => {
    setPageNumber(1);
    getReportData("0", rowsPerPage);
  }, [getReportData, rowsPerPage]);

  const handleAdminSearch = useCallback(() => {
    console.log('🔄 Auto-run button clicked');
    console.log('Current state - isAdminSearching:', isAdminSearching);
    console.log('Current state - autoRun:', autoRun);
    
    if (!isAdminSearching && autoRun) {
      console.log('Action: Starting auto-refresh');
      startRequest();
      return;
    }
    
    console.log('Action: Stopping auto-refresh');
    stopRequest();
  }, [isAdminSearching, autoRun, startRequest, stopRequest]);

  const onPageChange = useCallback((value) => {
    setPageNumber(value);
    getReportData(value, rowsPerPage);
    stopRequest();
  }, [getReportData, rowsPerPage, stopRequest]);

  const onRowsPerPageChange = useCallback((v) => {
    setPageNumber(1);
    setRowsPerPage(Number(v));
    if (sellerReports?.length) {
      getReportData("0", v);
    }
    stopRequest();
  }, [getReportData, sellerReports?.length, stopRequest]);

  const customStyles = useMemo(() => ({
    control: (provided) => ({
      ...provided,
      background: isDarktheme ? "#242526" : "",
      border: "1px solid #242526",
    }),
    menu: (provided) => ({
      ...provided,
      background: isDarktheme ? "#242526" : "",
      color: isDarktheme ? "white" : "",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: isDarktheme ? "white" : "",
    }),
  }), [isDarktheme]);

  // Date increment/decrement functions
  const incrementDateFrom = useCallback(() => {
    const newDate = moment(dateFrom).add(1, 'days').toDate();
    setDateFrom(newDate);
  }, [dateFrom]);

  const decrementDateFrom = useCallback(() => {
    const newDate = moment(dateFrom).subtract(1, 'days').toDate();
    setDateFrom(newDate);
  }, [dateFrom]);

  const incrementDateTo = useCallback(() => {
    const newDate = moment(dateTo).add(1, 'days').toDate();
    setDateTo(newDate);
  }, [dateTo]);

  const decrementDateTo = useCallback(() => {
    const newDate = moment(dateTo).subtract(1, 'days').toDate();
    setDateTo(newDate);
  }, [dateTo]);

  const settingHandler = useCallback(async (report, sellerId, newAmount) => {
    setSettingLoading(true);
    try {
      await ApiRequest.post(
        `ppt?transid=${report.transid}&sellerid=${sellerId}&amount=${newAmount}`
      );
    } catch (e) {
      alert(e);
    }
    setSettingLoading(false);
  }, []);

  const updateTransactionStatusHandler = useCallback(async (report, status) => {
    try {
      await updateTransaction({
        ...report,
        transId: report.transid,
        value: status,
      });
      await getReportData(pageNumber, rowsPerPage);
    } catch (e) {
      alert(e);
    } finally {
      setSettingLoading(false);
    }
  }, [updateTransaction, getReportData, pageNumber, rowsPerPage]);

  const resetAll = useCallback(() => {
    setProvider({
      value: "",
      label: translate("Select Card Type"),
    });
    setCardType({
      value: "",
      label: translate("Select Card Type"),
    });
    setTransType({
      value: "",
      label: translate("Select Card Type"),
    });
    setTransStatus({
      value: "",
      label: translate("Select Card Type"),
    });
    setDateFrom(new Date());
    setDateTo(new Date());
    setCancelRequests(false);
    setCanceled(false);
    setAutoRenew(false);
    setAutoRun(false);
    setLocation("");
    setAmount("");
    setTransId("");
    setPhone("");
    setSelectedUserType("");
    setResellerId("");
    setTopUpAccountNo("");
    setCardId("");
    setNote("");
  }, []);

  const renderUserTypesDropdown = useMemo(() => (
    <UserTypesDropdown
      sellersOptions={sellersOptions}
      selectedSeller={seller}
      selectedUserType={selectedUserType}
      onSelectUserType={(value) => setSelectedUserType(value)}
      disabled={false}
      onSelectSeller={(value) => {
        setSeller(value || { value: "", label: translate("Select all") });
      }}
    />
  ), [sellersOptions, seller, selectedUserType]);

  // Calculate totals per biller
  const billerTotals = useMemo(() => {
    if (!sellerReports || sellerReports.length === 0) return [];
    
    const totalsMap = {};
    
    sellerReports.forEach((report) => {
      const provider = report.provider || translate("Unknown");
      const amount = parseFloat(report.cardamount) || 0;
      
      if (!totalsMap[provider]) {
        totalsMap[provider] = {
          provider: provider,
          totalAmount: 0,
          count: 0,
          logo: report.provider_logo_url || "",
        };
      }
      
      totalsMap[provider].totalAmount += amount;
      totalsMap[provider].count += 1;
    });
    
    return Object.values(totalsMap).sort((a, b) => b.totalAmount - a.totalAmount);
  }, [sellerReports]);

  const loadAllDataForStatistics = useCallback(() => {
    // Load all data (max 10000 rows) for statistics
    return getSellerReports(
      moment(dateFrom).format("YYYY-MM-DD"),
      moment(dateTo).format("YYYY-MM-DD"),
      phone,
      transType.value,
      transStatus.value,
      transId,
      cardId,
      cancelRequest,
      canceled,
      amount,
      renew,
      provider.value,
      cardType.value,
      "0", // page 0
      "10000", // load ALL rows
      seller ? seller?.value : jsonParser(localStorage.currentUser).id,
      resellerId,
      topUpAccountNo?.value,
      location,
      "sales",
      note
    );
  }, [dateFrom, dateTo, phone, transType.value, transStatus.value, transId, cardId, cancelRequest, canceled, amount, renew, provider.value, cardType.value, seller, resellerId, topUpAccountNo?.value, location, note, getSellerReports]);

  const renderSaleReportTable = useMemo(() => (
    <SaleReportTable
      count={totalCount}
      onRefresh={() => getReportData()}
      onSearch={handleSearch}
      onReset={resetAll}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      isLoading={loading}
      onEditClick={updateTransactionStatusHandler}
      title={translate("Sales Table")}
      page={pageNumber}
      rowsPerPage={rowsPerPage}
      totalText={translate("Total Sales")}
      onSettingClick={settingHandler}
      onLoadingSetting={settingLoading}
      showBillerTotals={showBillerTotals}
      onToggleBillerTotals={setShowBillerTotals}
      onLoadStatisticsData={loadAllDataForStatistics}
      // Header toggles
      cancelRequest={cancelRequest}
      onToggleCancelRequest={(v) => setCancelRequests(!!v)}
      canceled={canceled}
      onToggleCanceled={(v) => setCanceled(!!v)}
      renew={renew}
      onToggleRenew={(v) => setAutoRenew(!!v)}
      autoRun={autoRun}
      isAdminSeller={isAdminSeller}
      isAdminSearching={isAdminSearching}
      onToggleAutoRun={(v) => {
        const next = !!v;
        console.log('Auto-run checkbox changed to:', next);
        setAutoRun(next);
        if (next && !isAdminSearching) {
          console.log('Checkbox enabled - starting request');
          startRequest();
        } else if (!next) {
          console.log('Checkbox disabled - stopping request');
          stopRequest();
        }
      }}
      sage50FilterParams={{
        dateFrom,
        dateTo,
        phone,
        transType: transType.value,
        transStatus: transStatus.value,
        transId,
        cardId,
        cancelRequest,
        canceled,
        amount,
        renew,
        provider: provider.value,
        cardType: cardType.value,
        seller: seller ? seller?.value : sellerId,
        resellerId,
        topUpAccountNo: topUpAccountNo?.value,
        location,
        note,
      }}
    />
  ), [totalCount, getReportData, onPageChange, onRowsPerPageChange, loading, updateTransactionStatusHandler, pageNumber, rowsPerPage, settingHandler, settingLoading, showBillerTotals, dateFrom, dateTo, phone, transType.value, transStatus.value, transId, cardId, cancelRequest, canceled, amount, renew, provider.value, cardType.value, seller, sellerId, resellerId, topUpAccountNo, location, note, isAdminSeller, isAdminSearching, handleAdminSearch, handleSearch, resetAll]);

  const renderRestIcon = useMemo(() => (
    <IconButton
      title={intl.formatMessage({ id: "reset" })}
      color="primary"
      style={{ padding: 4, marginRight: 8 }}
      onClick={resetAll}
    >
      <RestartAltIcon />
    </IconButton>
  ), [intl, resetAll]);

  return (
    <>
      <div>
        <ReportHeader 
          cancelRequest={cancelRequest}
          setCancelRequests={setCancelRequests}
          canceled={canceled}
          setCanceled={setCanceled}
          renew={renew}
          setAutoRenew={setAutoRenew}
          autoRun={autoRun}
          setAutoRun={setAutoRun}
          disableAttr={disableAttr}
          isAdminSeller={isAdminSeller}
          isAdminSearching={isAdminSearching}
        />
        <Grid container justifyContent="center" spacing={0.5} paddingTop={"2px"} marginBottom={"4px"}>
          <Grid
            item
            md={12}
            xs={12}
            container
            spacing={0.5}
            className={classes.gridContainer}
          >
            <Grid
              item
              md={3}
              xs={12}
              sm={6}
              className="report-dropdown-container"
            >
              <Dropdown
                className="report-dropdown"
                options={transStatusOptions}
                onChange={(value) => setTransStatus(value)}
                value={transStatus}
                key={transStatus.value}
                disabled={disableAttr}
              />
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              sm={6}
              className="report-dropdown-container"
            >
              <Dropdown
                className="report-dropdown"
                options={options}
                onChange={(value) => setTransType(value)}
                value={transType}
                key={transType.value}
                disabled={disableAttr}
              />
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              sm={6}
              className="report-dropdown-container"
            >
              <Select
                options={companies}
                value={provider}
                isClearable
                onChange={(value) => setProvider(value)}
                isDisabled={disableAttr}
              />
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              sm={6}
              className="report-dropdown-container"
            >
              <Dropdown
                options={cardTypeOptions}
                value={cardType}
                key={cardType.value}
                className="report-dropdown"
                onChange={(value) => setCardType(value)}
                disabled={disableAttr}
              />
            </Grid>
            <Grid item md={3} xs={12} sm={6}>
              <CancelableInput
                onChange={(element) => setPhone(element.target.value)}
                className="form-control report-input-left-column"
                placeholder={intl.formatMessage({ id: "Mobile No." })}
                onClearClick={(e) => setPhone("")}
                value={phone}
                disabled={disableAttr}
              />
            </Grid>
            <Grid item md={3} xs={12} sm={6}>
              <CancelableInput
                onClearClick={(e) => {
                  setTransId("");
                }}
                value={transId}
                onChange={(element) => setTransId(element.target.value)}
                style={{ marginTop: 0 }}
                className="form-control report-input-left-column"
                placeholder={intl.formatMessage({ id: "movmentNo" })}
                disabled={disableAttr}
              />
            </Grid>
            <Grid item md={3} xs={12} sm={6}>
              <CancelableInput
                onChange={(element) => setCardId(element.target.value)}
                className="form-control report-input-left-column"
                placeholder={intl.formatMessage({ id: "card_id" })}
                disabled={disableAttr}
                onClearClick={(e) => setCardId("")}
                value={cardId}
                style={{ marginTop: 0 }}
              />
            </Grid>
            <Grid item md={3} xs={12} sm={6}>
              <CancelableInput
                onChange={(element) => setAmount(element.target.value)}
                className="form-control report-input-left-column"
                placeholder={intl.formatMessage({ id: "amount" })}
                disabled={disableAttr}
                onClearClick={(e) => setAmount("")}
                value={amount}
                style={{ marginTop: 0 }}
              />
            </Grid>
            {conditionalReturn(
              isAdminSeller || isReseller,
              <Grid item md={3} xs={12} sm={6}>
                {renderUserTypesDropdown}
              </Grid>
            )}
            {conditionalReturn(
              isAdminSeller || isReseller,
              <>
                <Grid item md={3} xs={12} sm={6}>
                  <CancelableInput
                    onChange={(element) => setResellerId(element.target.value)}
                    className="form-control report-input-left-column"
                    placeholder={intl.formatMessage({ id: "reseller_id" })}
                    onClearClick={(e) => setResellerId("")}
                    value={resellerId}
                    disabled={disableAttr}
                  />
                </Grid>
                <Grid item md={3} xs={12} sm={6}>
                  <CancelableInput
                    onChange={(element) => setLocation(element.target.value)}
                    className="form-control report-input-left-column"
                    placeholder={intl.formatMessage({ id: "location" })}
                    onClearClick={(e) => setLocation("")}
                    value={location}
                    disabled={disableAttr}
                  />
                </Grid>
              </>
            )}
            {conditionalReturn(
              isAdminSeller,
              <Grid
                item
                md={3}
                xs={12}
                sm={6}
                className="report-dropdown-container"
              >
                <Select
                  options={formatTopUpAccountsOptionsForSelect(
                    topUpAccounts || []
                  )}
                  value={topUpAccountNo}
                  isClearable
                  className="report-dropdown"
                  onChange={(val) => setTopUpAccountNo(val)}
                  id="topUpDropDown"
                  isDisabled={disableAttr}
                />
                <div className="carrierLabelDiv">
                  <label>{topUpAccountNo?.carrier}</label>
                </div>
              </Grid>
            )}

            <Grid item md={3} xs={12} sm={12}>
              <CancelableInput
                onChange={(element) => setNote(element.target.value)}
                className="form-control report-input-left-column"
                placeholder={intl.formatMessage({ id: "Note" })}
                onClearClick={(e) => setNote("")}
                value={note}
                disabled={disableAttr}
              />
            </Grid>

            <Grid item md={3} xs={5}>
              <div style={{ width: "100%", position: "relative" }}>
                <DatePicker
                  selected={dateFrom}
                  type="date"
                  dateFormat="dd-MM-yyyy"
                  placeholderText={intl.formatMessage({ id: "dd-MM-yyyy" })}
                  className={"date-picker form-control"}
                  disabled={disableAttr}
                  onChange={(e) => setDateFrom(e)}
                />
                <IconButton
                  size="small"
                  onClick={decrementDateFrom}
                  disabled={disableAttr}
                  title="Previous Day"
                  sx={{
                    position: "absolute",
                    left: 4,
                    top: "50%",
                    transform: "translateY(-50%)",
                    padding: "2px",
                  }}
                >
                  <KeyboardArrowLeftIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={incrementDateFrom}
                  disabled={disableAttr}
                  title="Next Day"
                  sx={{
                    position: "absolute",
                    right: 4,
                    top: "50%",
                    transform: "translateY(-50%)",
                    padding: "2px",
                  }}
                >
                  <KeyboardArrowRightIcon fontSize="small" />
                </IconButton>
              </div>
            </Grid>
            <Grid item md={3} xs={5}>
              <div style={{ width: "100%", position: "relative" }}>
                <DatePicker
                  selected={dateTo}
                  type="date"
                  dateFormat="dd-MM-yyyy"
                  placeholderText={intl.formatMessage({ id: "dd-MM-yyyy" })}
                  className={"date-picker form-control"}
                  disabled={disableAttr}
                  onChange={(e) => setDateTo(e)}
                />
                <IconButton
                  size="small"
                  onClick={decrementDateTo}
                  disabled={disableAttr}
                  title="Previous Day"
                  sx={{
                    position: "absolute",
                    left: 4,
                    top: "50%",
                    transform: "translateY(-50%)",
                    padding: "2px",
                  }}
                >
                  <KeyboardArrowLeftIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={incrementDateTo}
                  disabled={disableAttr}
                  title="Next Day"
                  sx={{
                    position: "absolute",
                    right: 4,
                    top: "50%",
                    transform: "translateY(-50%)",
                    padding: "2px",
                  }}
                >
                  <KeyboardArrowRightIcon fontSize="small" />
                </IconButton>
              </div>
            </Grid>
          </Grid>
        </Grid>
        {/* Compact row removed: toggles moved to header */}
        {/* Removed extra totals grid and spacer for a more compact layout */}

        {/* Total Sales/Transactions Summary Bar - Between Filters and Report */}
        {sellerReports && sellerReports.length > 0 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 3,
              padding: "12px 24px",
              backgroundColor: isDarktheme ? "#2d2d2d" : "#f8fafc",
              borderTop: "1px solid " + (isDarktheme ? "#444" : "#e2e8f0"),
              borderBottom: "2px solid " + (isDarktheme ? "#555" : "#cbd5e1"),
              margin: "8px 0 16px 0",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                padding: "8px 16px",
                backgroundColor: isDarktheme ? "#1a1a1a" : "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 3px rgba(0,0,0,0.06)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  color: isDarktheme ? "#94a3b8" : "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {translate("Total Transactions")}:
              </Typography>
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#1976d2",
                }}
              >
                {parseInt(sellerReports[0]?.total_count || 0).toLocaleString()}
              </Typography>
            </Box>
            
            <Box
              sx={{
                width: "2px",
                height: "32px",
                backgroundColor: isDarktheme ? "#555" : "#cbd5e1",
              }}
            />
            
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                padding: "8px 16px",
                backgroundColor: isDarktheme ? "#1a1a1a" : "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 3px rgba(0,0,0,0.06)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  color: isDarktheme ? "#94a3b8" : "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {translate("Total Sales")}:
              </Typography>
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#059669",
                }}
              >
                ₪{parseFloat(sellerReports[0]?.total_sales || 0).toLocaleString()}
              </Typography>
            </Box>
          </Box>
        )}

        {renderSaleReportTable}

        {/* Biller Totals Summary */}
        {showBillerTotals && billerTotals.length > 0 && (
          <div style={{ 
            marginTop: "24px", 
            marginBottom: "24px",
            padding: "20px",
            borderRadius: "12px",
            background: isDarktheme 
              ? "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)" 
              : "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
            border: `1px solid ${isDarktheme ? "#333" : "#cbd5e1"}`,
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
          }}>
            <Typography 
              variant="h6" 
              fontWeight="bold" 
              gutterBottom
              style={{
                color: isDarktheme ? "#fff" : "#1e293b",
                marginBottom: "16px",
                fontSize: "18px"
              }}
            >
              {translate("Total Sales by Biller")}
            </Typography>
            <Grid container spacing={2}>
              {billerTotals.map((biller, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                  <div
                    style={{
                      border: `2px solid ${isDarktheme ? "#374151" : "#e5e7eb"}`,
                      borderRadius: "10px",
                      padding: "12px",
                      backgroundColor: isDarktheme ? "#1f2937" : "#ffffff",
                      transition: "all 0.3s ease",
                      cursor: "default",
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      minHeight: "110px"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.15)";
                      e.currentTarget.style.borderColor = "#047857";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.borderColor = isDarktheme ? "#374151" : "#e5e7eb";
                    }}
                  >
                    {/* Provider header with logo */}
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "4px" }}>
                      {biller.logo && (
                        <img
                          src={biller.logo}
                          alt={biller.provider}
                          style={{
                            width: "45px",
                            height: "45px",
                            minWidth: "45px",
                            minHeight: "45px",
                            maxWidth: "45px",
                            maxHeight: "45px",
                            objectFit: "contain",
                            borderRadius: "6px",
                            padding: "2px",
                            background: isDarktheme ? "#374151" : "#f3f4f6"
                          }}
                        />
                      )}
                      <Typography 
                        variant="subtitle2" 
                        fontWeight="700"
                        style={{
                          color: isDarktheme ? "#f9fafb" : "#111827",
                          fontSize: "14px",
                          lineHeight: "1.2"
                        }}
                      >
                        {biller.provider}
                      </Typography>
                    </div>
                    
                    {/* Amount */}
                    <div style={{ 
                      display: "flex", 
                      justifyContent: "space-between", 
                      alignItems: "center",
                      padding: "4px 0"
                    }}>
                      <Typography 
                        variant="body2" 
                        style={{ 
                          color: isDarktheme ? "#9ca3af" : "#6b7280",
                          fontSize: "12px"
                        }}
                      >
                        {translate("Total Amount")}:
                      </Typography>
                      <Typography 
                        variant="body2" 
                        fontWeight="bold"
                        style={{ 
                          color: "#047857",
                          fontSize: "14px"
                        }}
                      >
                        {biller.totalAmount.toFixed(2)}
                      </Typography>
                    </div>
                    
                    {/* Transactions count */}
                    <div style={{ 
                      display: "flex", 
                      justifyContent: "space-between", 
                      alignItems: "center",
                      padding: "4px 0"
                    }}>
                      <Typography 
                        variant="body2" 
                        style={{ 
                          color: isDarktheme ? "#9ca3af" : "#6b7280",
                          fontSize: "12px"
                        }}
                      >
                        {translate("Transactions")}:
                      </Typography>
                      <Typography 
                        variant="body2" 
                        fontWeight="bold"
                        style={{ 
                          color: isDarktheme ? "#60a5fa" : "#2563eb",
                          fontSize: "14px"
                        }}
                      >
                        {biller.count}
                      </Typography>
                    </div>
                  </div>
                </Grid>
              ))}
            </Grid>
          </div>
        )}

        <Modal
          visible={updateTransactionModal}
          onClose={() => setUpdateTransactionModal(false)}
          title={translate("Update Transaction")}
          width="400px"
          onSuccess={async () => {
            await updateTransaction(updateTransactionData);
            setUpdateTransactionModal(false);
            getReportData(0);
          }}
          onSuccessLoading={updateTransactionLoading}
        >
          <div
            style={{
              height: "150px",
              marginTop: "26px",
            }}
          >
            <Select
              options={transactionOptions}
              value={updateTransactionStatus}
              className="report-dropdown"
              onChange={(event) => {
                setUpdateTransactionData({
                  ...updateTransactionData,
                  value: event.value,
                });
                setUpdateTransactionStatus(event);
              }}
              isDisabled={disableAttr}
              styles={{ height: "32px", ...customStyles }}
            />
          </div>
        </Modal>

        {/* Floating Scroll to Top Button */}
        {showScrollTop && (
          <IconButton
            onClick={scrollToTop}
            style={{
              position: 'fixed',
              bottom: '30px',
              right: '30px',
              backgroundColor: '#047857',
              color: '#ffffff',
              width: '56px',
              height: '56px',
              boxShadow: '0 4px 12px rgba(4, 120, 87, 0.4)',
              zIndex: 1000,
              transition: 'all 0.3s ease',
              border: '2px solid rgba(255, 255, 255, 0.2)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#059669';
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(4, 120, 87, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#047857';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(4, 120, 87, 0.4)';
            }}
            title={translate("Back to Top")}
          >
            <KeyboardArrowUpIcon style={{ fontSize: '32px' }} />
          </IconButton>
        )}

        {/* Floating Scroll to Bottom Button */}
        {showScrollBottom && (
          <IconButton
            onClick={scrollToBottom}
            style={{
              position: 'fixed',
              bottom: '30px',
              right: '100px',
              backgroundColor: '#2563eb',
              color: '#ffffff',
              width: '56px',
              height: '56px',
              boxShadow: '0 4px 12px rgba(37, 99, 235, 0.4)',
              zIndex: 1000,
              transition: 'all 0.3s ease',
              border: '2px solid rgba(255, 255, 255, 0.2)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#1d4ed8';
              e.currentTarget.style.transform = 'translateY(4px)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(37, 99, 235, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#2563eb';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.4)';
            }}
            title={translate("Go to Bottom")}
          >
            <KeyboardArrowDownIcon style={{ fontSize: '32px' }} />
          </IconButton>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  sellerReports: state.reports.sellerReports,
  discounts: state.discounts.discounts,
  gameArray: state.games.gamesArray,
  auth: state.auth,
  sellers: state.credits.sellers,
  isDarktheme: state.darkTheme.isDarktheme,
  updateTransactionLoading: state.reports.updateTransactionLoading,
});

export default connect(mapStateToProps, {
  getSellerReports,
  getDiscounts,
  getGamingCards,
  getSellers,
  updateTransaction,
})(Report);
